import gsap from "gsap";
import { isTouchDevice } from "./isTouchDevice";

export const lineupCursor = () => {
  if (document.querySelector(".js-lineup-cursor-target") === null || isTouchDevice() === true) return;

  const cursor = document.querySelector(".js-lineup-cursor");
  const cursorTargets = document.querySelectorAll(".js-lineup-cursor-target");
  const pos = { x: 0, y: 0 }; // カーソル要素の座標
  const mouse = { x: pos.x, y: pos.y }; // マウスカーソルの座標
  const speed = 0.8; // 0.01〜1 数値が大きほど早い

  // カーソルの座標を設定する
  var cursorSetX = gsap.quickSetter(cursor, "x", "px");
  var cursorSetY = gsap.quickSetter(cursor, "y", "px");

  // 遅延するカーソルの座標を設定する

  // マウスカーソル座標を取得する
  document.addEventListener("mousemove", function (event) {
    mouse.x = event.pageX;
    mouse.y = event.pageY;
  });

  // レンダリングする
  gsap.ticker.add(function () {
    var dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

    pos.x += (mouse.x - pos.x) * dt;
    pos.y += (mouse.y - pos.y) * dt;
    cursorSetX(pos.x);
    cursorSetY(pos.y);
  });

  cursorTargets.forEach((target) => {
    // マウスムーブ時に矢印の向きを更新する関数
    const updateRotation = (e) => {
      const rect = target.getBoundingClientRect();
      const midX = rect.left + rect.width / 2;
      // 要素内で左半分なら rotation 0、右半分なら rotation 180（矢印画像に合わせて調整）
      const rotationValue = e.clientX < midX ? 180 : 0;
      gsap.to(cursor, { rotation: rotationValue, duration: 0.2 });
    };

    // ホバー開始時にカーソル表示＆mousemoveイベントを追加
    target.addEventListener("mouseenter", (e) => {
      gsap.to(cursor, { autoAlpha: 1, duration: 0.6 });
      target.addEventListener("mousemove", updateRotation);
      // 初回判定をすぐに行うため、mouseenterの時点でも更新
      updateRotation(e);
    });

    // ホバー終了時にカーソル非表示＆mousemoveイベントを解除
    target.addEventListener("mouseleave", () => {
      gsap.to(cursor, { autoAlpha: 0, duration: 0.6 });
      target.removeEventListener("mousemove", updateRotation);
    });

    // target.addEventListener("mouseleave", () => {
    //   gsap.to(cursor, { autoAlpha: 0, duration: 0.6 });
    // });
  });
};
